module.exports = __webpack_public_path__ + "media/images/logo/Logo(H)_NavyOL-b01ecc5ec0c457a2a7610b20a37dfaef.png";